import React from "react";

const Checkbox = ({
  label,
  checked,
  id,
  onChange,
  className = "",
  disabled = false,
}) => {
  return (
    <label
      className={`flex items-center space-x-2.5 group cursor-pointer ${
        disabled ? "cursor-not-allowed opacity-50" : ""
      }`}
    >
      <div className="relative w-4 h-4">
        <input
          id={id}
          type="checkbox"
          className={`w-4 h-4 appearance-none cursor-pointer border border-gray-700 bg-gray-950 rounded-sm checked:bg-white checked:border-white transition-all ${className}`}
          checked={checked}
          onChange={(e) => onChange(e.target.checked)}
          disabled={disabled}
        />
        {checked && (
          <svg
            className="absolute top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 pointer-events-none"
            xmlns="http://www.w3.org/2000/svg"
            width="10"
            height="10"
            viewBox="0 0 14 14"
            fill="none"
          >
            <path
              d="M11.6666 3.5L5.24992 9.91667L2.33325 7"
              stroke="black"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        )}
      </div>
      {label && (
        <span className="text-xs font-medium text-gray-400 group-hover:text-gray-200 transition-colors">
          {label}
        </span>
      )}
    </label>
  );
};

export default Checkbox;
